import React, { ReactNode } from 'react';
import './CardContainer.less';

export type CardContainerProps = {
  children?: ReactNode;
  background?:
    | 'light-100'
    | 'light-50'
    | 'light-30'
    | 'light-20'
    | 'light-10'
    | 'white';
  borderd?: boolean;
  bordered10?: boolean;
  shadow?: boolean;
  divider?: boolean;
  style?: React.CSSProperties;
  highlighted?: boolean;
};
const TCardContainer: React.FC<CardContainerProps> = ({
  children,
  background = 'white',
  borderd,
  bordered10,
  shadow = true,
  divider = false,
  style,
  highlighted,
}) => {
  const classNames = ['t-card-container', `t-card-container-bg-${background}`];
  if (!!bordered10) {
    classNames.push('t-card-container-borderd10');
  }
  if (!!borderd) {
    classNames.push('t-card-container-borderd');
  }
  if (!!shadow) {
    classNames.push('t-card-container-with-shadow');
  }
  if (!!divider && !shadow) {
    classNames.push('t-card-container-with-divider');
  }
  if (!!highlighted) {
    classNames.push('t-card-container-highlighted');
  }
  return (
    <div style={style} className={classNames.join(' ')}>
      {children}
    </div>
  );
};

export default TCardContainer;
